<p-table
  #pt
  [value]="messageTemplates"
  [paginator]="true"
  [rows]="25"
  [rowsPerPageOptions]="[25,100,200]"
  [lazy]="true"
  (onLazyLoad)="loadLazy($event)"
  [totalRecords]="recordTotal"
  [responsive]="true"
  sortMode="multiple"
  selectionMode="single"
  [(selection)]="messageTemplate"
  dataKey="messageTemplateId"
  (onRowSelect)="onRowSelect($event)"
  [loading]="loading"> <ng-template pTemplate="caption"> <i
  class="fa fa-search"
style="margin:4px 4px 0 0;"></i> <!-- <input type="text" pInputText placeholder="Search" (input)="pt.filterGlobal($event.target.value, 'contains')" style="width:auto;"> -->
<div align="right">
  <button
    mat-raised-button
    color="primary"
  routerLink="/message-template-add">Add Message Template +</button>
</div>
</ng-template> <ng-template pTemplate="header">
<tr>
  @for (col of columns; track col) {
    <th
      [pSortableColumn]="col.field">{{col.header}} <p-sortIcon [field]="col.field"></p-sortIcon>
    </th>
  }
</tr>
<tr>
  @for (col of columns; track col) {
    <th
      >
      @switch (col.field) {@case ('messageTemplateId') {
        <input
          pInputText
          type="number"
          (input)="pt.filter($event.target.value, col.field, col.filterMatchMode)">
        } @case ('startDate') {
        <input
          pInputText
          type="text"
          (input)="pt.filter($event.target.value, col.field, col.filterMatchMode)">
        } @case ('endDate') {
        <input
          pInputText
          type="text"
          (input)="pt.filter($event.target.value, col.field, col.filterMatchMode)">
        }}
      </th>
    }
  </tr>
</ng-template> <ng-template
pTemplate="body"
let-messageTemplate>
<tr [pSelectableRow]="messageTemplate">
  @for (col of columns; track col) {
    <td>{{messageTemplate[col.field]}}</td>
  }
</tr>
</ng-template> <ng-template pTemplate="paginatorleft"> Showing {{recordTotal < 1 ? 0 : (lazyLoadEvent.first + 1)}} - {{recordTotal > 0 ? ((lazyLoadEvent.rows+ lazyLoadEvent.first) <= recordTotal ? (lazyLoadEvent.rows + lazyLoadEvent.first)
: recordTotal) : 0}} of {{recordTotal ? recordTotal : 0}} </ng-template> </p-table>
